import { Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import { FaArrowRight } from "@onemind-services-llc/react-icons-ng/fa";

import OemConverged from "public/privateCloud/oem-converged-architecture.webp";

export const INTRO_CONSTANTS = {
  title: "OEM Converged Architecture ",
  description: [
    "Integrating OEM systems into a cohesive cloud strategy can be complex—but OneMind simplifies it. We offer a Multi-Vendor Hosted Converged Cloud, partnering with industry-leading OEMs like Dell, Cisco, Pure Storage, and NetApp to deliver powerful private cloud solutions tailored to enterprise needs.",
    "Our approach to OEM Converged Architecture focuses on harmonizing devices, hardware, and software within a unified, cloud-native environment that supports agility at scale. By leveraging standardized compute, networking, and security frameworks, we enable seamless interoperability across cloud, edge, and hybrid deployments. The result is an infrastructure that not only performs efficiently but also scales intelligently—with minimal overhead.",
    "With OneMind managing the convergence, organizations gain greater control, visibility, and security across their ecosystem—without the traditional integration challenges.",
  ],
  points: [
    "Optimized infrastructure for OEM applications ",
    "Unified deployment with existing IT systems ",
    "Built to scale from edge to core to cloud",
    "Enhanced security, performance, and scalability",
  ],
  children: (
    <Button
      variant={"ideal"}
      mt={2}
      p={4}
      whiteSpace={"pre-line"}
      onClick={() => scrollToElement("contact-us", 120)}
      rightIcon={<FaArrowRight />}
      width="fit-content"
    >
      Request OEM Converged Architecture Solutions Pricing
    </Button>
  ),
  image: OemConverged,
};
